import React from 'react';
import Modal from '~/components/modal';
import DataTable from '~/components/datatable';
import { formats } from '~/helper';
import usePartners from '~/view-data/use-partners'; // Substitui a importação direta por usePartners

const ModalEditContract = ({ isOpen, onClose, contractData }) => {
  const [partners, setPartners] = React.useState([]);
  const [selectedPartner, setSelectedPartner] = React.useState(null); // Inicializa como null para 'Novo Parceiro'
  const [searchTerm, setSearchTerm] = React.useState(''); // Estado para o termo de busca
  const { actions: { fetchSimpleList, updatePartner } } = usePartners(); // Obtém updatePartner e load do hook usePartners
  const fetchSimpleListRef = React.useRef(fetchSimpleList); // Armazena a referência de fetchSimpleList

  React.useEffect(() => {
    let isMounted = true; // Flag para verificar se o componente está montado

    const loadPartners = async () => {
      const data = await fetchSimpleListRef.current(); // Usa a referência para evitar recriação
      if (isMounted) {
        setPartners(data);
      }
    };

    loadPartners();

    return () => {
      isMounted = false; // Define como falso ao desmontar o componente
    };
  }, []); // Remove fetchSimpleList do array de dependências

  const handleSave = async () => {
    if (selectedPartner) {
      const { id: contractId, partner } = contractData;
      const { id: newPartnerId, name: newPartnerName, identity: newPartnerIdentity } = selectedPartner;
      const oldPartnerName = partner?.name || 'Nome não disponível';
      const oldPartnerIdentity = partner?.identity || 'CNPJ não disponível';

      await updatePartner({
        contractId,
        newPartnerId,
        oldPartnerName,
        oldPartnerIdentity,
        newPartnerName,
        newPartnerIdentity
      });

      onClose(); // Fecha o modal
    }
  };

  const handleRowClick = (row) => {
    setSelectedPartner(row); // Preenche os campos de 'Novo Parceiro' somente ao selecionar uma linha
  };

  const columns = [
    { name: 'ID', selector: 'id', width: '70px' },
    { name: 'CNPJ', selector: 'identity', format: row => formats.cnpj(row.identity) },
    { name: 'Nome', selector: 'name' }
  ];

  const filteredPartners = partners.filter(partner => {
    const searchLower = searchTerm.toLowerCase();
    return (
      partner.name.toLowerCase().includes(searchLower) ||
      partner.identity.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Modal
      open={isOpen}
      title="Alteração de Parceiro"
      onClose={onClose}
      actions={[
        { label: 'Cancelar', action: onClose },
        { label: 'Salvar', action: handleSave, primary: true, disabled: !selectedPartner }
      ]}
    >
      <div>
        <h3>Dados do Contrato</h3>
        <p><strong>ID:</strong> {contractData.id}</p>
        <p><strong>Grupo:</strong> {contractData.groupName}</p>
        <p><strong>Início:</strong> {formats.dateTimeZone(contractData.startDate, 'dd/MM/yyyy')}</p>
        <p><strong>Número do Contrato:</strong> {contractData.controlContractNumber || 'Não disponível'}</p>
        <br />

        <h3 style={{ color: 'white', backgroundColor: '#4180aa', padding: '5px' }}>Parceiro Atual</h3> {/* Fundo branco com borda #4180aa */}
        <p style={{ color: 'white', backgroundColor: '#4180aa', padding: '5px' }}><strong>CNPJ:</strong> {formats.cnpj(contractData.partner?.identity) || 'CNPJ não disponível'}</p>
        <p style={{ color: 'white', backgroundColor: '#4180aa', padding: '5px' }}><strong>Nome:</strong> {contractData.partner?.name || 'Nenhum selecionado'}</p>
        <br />

        <h3 style={{ color: 'white', backgroundColor: '#477b4b', padding: '5px' }}>Novo Parceiro</h3>
        <p style={{ color: 'white', backgroundColor: '#477b4b', padding: '5px' }}><strong>CNPJ:</strong> {selectedPartner?.identity ? formats.cnpj(selectedPartner.identity) : 'CNPJ não selecionado'}</p>
        <p style={{ color: 'white', backgroundColor: '#477b4b', padding: '5px' }}><strong>Nome:</strong> {selectedPartner?.name || 'Nome não selecionado'}</p>
      </div>

      <div style={{ width: '100%' }}> {/* Ajusta o DataTable para ocupar toda a largura */}
        <h3>Selecione um Parceiro</h3>
        <input
          type="text"
          placeholder="Buscar por nome ou CNPJ"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '10px', width: '100%', padding: '5px' }}
        />
        <DataTable
          columns={columns}
          data={{ rows: filteredPartners }}
          keyField="id"
          onRowClicked={handleRowClick} // Atualiza os campos ao clicar em uma linha
          noPagination={true}
          emptyText="Nenhum parceiro encontrado"
        />
      </div>
    </Modal>
  );
};

export default ModalEditContract;